import React, {
  useRef,
  useState,
  useEffect,
  useCallback,
  useMemo,
} from "react";
import PropTypes from "prop-types";
import {
  List,
  ListItem,
  Collapse,
  Box,
  Typography,
  Avatar,
  IconButton,
  CardHeader,
  CardContent,
  Popover,
  Chip,
} from "@mui/material";
import {
  MoreVert as MoreVertIcon,
  Send as SendIcon,
  DeleteForever as DeleteForeverIcon,
  Reply as ReplyIcon,
  ExpandLess,
  ExpandMore,
  Edit as EditIcon,
} from "@mui/icons-material";
import { useSelector, useDispatch } from "react-redux";
import { resetState } from "../users/usersSlice";
//import CustomSingleInputMention from "../custom-mention/CustomSingleInputMention";
import {
  getIntlTranslation,
  random_hex_color_code,
  getVariantText,
  getTranslationVariantText,
  getAllEmailRegex,
} from "../../../utils/helper";
import CustomIconButton from "../../../components/buttons/icons-buttons/CustomIconButton";
import CustomButton from "../../../components/buttons/CustomButton";
import SaveIcon from "@mui/icons-material/Save";
import CommentContainerMention from "../mention/CommentContainerMention";

const RecursiveCommentList = (props) => {
  const {
    key,
    scrollId,
    data,
    parentCommentValue,
    setInputValue,
    inputValue,
    users,
    handleDelete,
    handleEditSave,
    handleReply,
    scrollTo,
  } = props;
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [showReply, setShowReply] = useState(false);
  const [showEditComment, setShowEditComment] = useState(null);
  //const [commentUser, setCommentUser] = useState({});
  const [replyValue, setReplyValue] = useState({});
  const [editValue, setEditValue] = useState({});
  const [replyParentData, setReplyParentData] = useState({});
  const [lastComment, setLastComment] = useState({});
  const [lastCommentDate, setLastCommentDate] = useState("");
  const [seletedValue, setSeletedValue] = useState({});
  const system = useSelector((state) => state.system);

  useEffect(() => {
    setInputValue({
      val: data.value,
      ident: data.ident,
    });
  }, [data]);

  function replaceMentionsWithHmtl(text) {
    const mentionRegex = /\[@(.+?)\((.+?)\)\]/g;
    const replacedWithText = text.replace(
      mentionRegex,
      '<span class="mention-User-Tag">$1</span>'
    );
    const htmlText = `<p>${replacedWithText}</p>`;
    return htmlText;
  }
  const formattedText = replaceMentionsWithHmtl(data.value);

  // function the get Last replies object data
  function getLastObject(obj, id) {
    let currentObj = {};
    if (Array.isArray(obj.replies) && obj.replies.length > 0) {
      currentObj = obj.replies[obj.replies.length - 1];
    }
    return currentObj;
  }

  // get the last comment
  useEffect(() => {
    if (!!replyParentData.id) {
      setLastComment(getLastObject(data, replyParentData.id));
    }
  }, [data]);

  //get the last comment date
  useEffect(() => {
    if (Object.keys(lastComment).length > 0) {
      let date = new Date(lastComment.creationDate).toDateString();
      setLastCommentDate(date);
    }
  }, [lastComment]);

  let countObjects = useCallback((obj) => {
    let count = 0;
    if (Array.isArray(obj.replies)) {
      count += obj.replies.length;
      for (const reply of obj.replies) {
        count += countObjects(reply);
      }
    }
    return count;
  }, []);

  let commentUser = useMemo(() => {
    let defaultUser = {
      firstName: "U",
      lastName: "K",
      display: "Unknown",
      userId: "0",
    };
    if (users.length > 0 && data) {
      const user = users.find((e) => e.userId === data.createdBy);
      return !!user ? user : defaultUser;
    } else {
      return defaultUser;
    }
  }, [data, users]);

  // click to show replies comment
  const showReplies = (val) => {
    if (open) {
      setSeletedValue({});
      setLastComment({});
    } else {
      setSeletedValue(val);
      setLastComment({});
    }
    setOpen(!open);
  };

  // click to get comment option example edit and delete
  const handleOptionClick = (event) => {
    setAnchorEl(event.currentTarget);
    if (inputValue.ident !== data.ident) {
      setShowEditComment(null);
    }
  };
  // close comment option
  const handleOptionClose = () => {
    setAnchorEl(null);
  };

  // replying comment function
  const handleReplyClick = (data) => {
    setShowReply(true);
    setReplyValue({
      val: "",
      ident: data.ident,
    });
    handleEditCancel();
  };

  const handleSaveReply = (item, value) => {
    setReplyParentData({
      id: item.ident,
      item: item,
    });
    handleReply(parentCommentValue, item, value);
    handleReplyClose(null);
  };
  const handleReplyClose = () => {
    setShowReply(null);
  };

  // editing comment function
  const handleEdit = (data, val) => {
    setEditValue({
      val: data.value,
      ident: data.ident,
    });
    setShowEditComment(anchorEl);
    handleOptionClose();
    handleReplyClose();
  };
  const handleEditCancel = () => {
    setShowEditComment(null);
  };
  const handleUpdateSave = (data, value) => {
    handleEditSave(parentCommentValue, data, value);
    setShowEditComment(null);
    setInputValue({
      val: value,
      ident: data.ident,
    });
  };

  // deleting comment function
  const handleDeleteClick = (val) => {
    handleDelete(parentCommentValue, val.ident);
    handleOptionClose();
  };

  const openPopover = Boolean(anchorEl);
  const commentsPopOverId = open ? "comments-action-popover" : undefined;
  let date = new Date(data.updatedAt);

  const replyContainer = (data) => {
    return (
      <Box
        style={{
          display: "flex",
          flexWrap: "nowrap",
          flexDirection: "column",
          width: "100%",
          justifyContent: "flex-end",
          alignItems: "center",
          height: "100%",
          flex: 1,
          margin: "5px 0px",
        }}
      >
        <Box
          style={{
            width: "100%",
            height: "100%",
            flex: 1,
            marginTop: 2,
            marginLeft: 2,
          }}
          className={"p-1"}
        >
          <CommentContainerMention
            placeholder="Add Comment. Enter @ to mention people"
            value={null}
            onClose={() => handleReplyClose()}
            onSave={(val) => handleSaveReply(data, val)}
          />
        </Box>
      </Box>
    );
  };

  return (
    <ListItem
      style={{
        display: "flex",
        flexDirection: "column",
        padding: 0,
        flexGrow: 1,
        cursor: "pointer",
        borderLeft:
          open && seletedValue.ident === data.ident
            ? `2px solid ${random_hex_color_code()}`
            : "none",
      }}
      className={"w-100 mt-2"}
      onClick={() => {
        scrollTo(scrollId);
      }}
      key={scrollId}
    >
      <CardHeader
        style={{ marginTop: 5 }}
        avatar={
          <Avatar
            style={{ backgroundColor: "#c1d0f0", width: 25, height: 25 }}
            className={"p-1 m-1"}
          >
            <Typography variant="caption">
              {commentUser?.firstName?.charAt(0).toUpperCase()}
              {commentUser?.lastName?.charAt(0).toUpperCase()}
            </Typography>
          </Avatar>
        }
        action={
          <>
            {commentUser.userId === data.createdBy && (
              <IconButton
                aria-describedby={commentsPopOverId}
                onClick={handleOptionClick}
                size="small"
              >
                <MoreVertIcon style={{ width: 20, height: 20 }} />
              </IconButton>
            )}
          </>
        }
        title={
          <>
            <div
              className={"d-flex w-100 flex-row flex-wrap align-items-center"}
            >
              <Typography
                variant="caption"
                style={{ fontWeight: "bold" }}
                className={"m-1"}
              >
                {commentUser?.display || "Unknown User"}
              </Typography>
              <Typography
                style={{
                  color: "grey",
                }}
                variant="caption"
              >
                {`${date.toLocaleString(system.language, {
                  weekday: "short",
                })},
                  ${date.toLocaleDateString(system.language)} , 
                  ${date.toLocaleTimeString(system.language)} ${
                  system.language === "de" ? "Uhr" : ""
                }`}
                {data.modified &&
                  getTranslationVariantText("_edited", "caption", {
                    textTransform: "uppercase",
                    marginLeft: 5,
                  })}
              </Typography>
            </div>
          </>
        }
        sx={{ padding: 0, maxHeight: 25, width: "100%", flex: 1 }}
      />
      <CardContent
        style={{
          display: "flex",
          flexDirection: "column",
          padding: 1,
          marginTop: 7,
          flex: 1,
          justifyContent: "flex-start",
          width: "100%",
        }}
      >
        {showEditComment && editValue.ident === data.ident ? (
          <Box
            style={{
              display: "flex",
              flexWrap: "nowrap",
              flexDirection: "column",
              width: "100%",
              minWidth: "100%",
              justifyContent: "flex-end",
              alignItems: "center",
              height: "100%",
              padding: 5,
              flex: 1,
            }}
          >
            <Box
              style={{ width: "100%", flex: 1, marginTop: 5, marginLeft: 1 }}
              className={"p-1"}
            >
              <CommentContainerMention
                placeholder="Add Comment. Enter @ to mention people"
                value={data.value}
                onClose={() => setShowEditComment()}
                onSave={(val) => handleUpdateSave(data, val)}
              />
            </Box>
          </Box>
        ) : (
          <Typography
            className={"p-2 m-1"}
            variant="body1"
            dangerouslySetInnerHTML={{ __html: formattedText }}
          />
        )}
        <Box className={"d-flex align-items-center w-100"}>
          {data.replies.length > 0 && (
            <Chip
              size="small"
              style={{
                marginLeft: 5,
                backgroundColor: "#C1D0F0",
                width: "40%",
              }}
              label={
                <>
                  {getVariantText(countObjects(data), "caption", {
                    color: "#254a9a",
                    fontWeight: "bold",
                    padding: 4,
                  })}
                  {getIntlTranslation("_replies", "caption", {
                    color: "#254a9a",
                    fontWeight: "bold",
                    padding: 4,
                  })}
                </>
              }
              onClick={(e) => showReplies(data)}
              deleteIcon={
                open ? (
                  <ExpandLess
                    style={{
                      width: 18,
                      height: 18,
                      color: "#254a9a",
                      order: 2,
                    }}
                  />
                ) : (
                  <ExpandMore
                    style={{
                      width: 18,
                      height: 18,
                      color: "#254a9a",
                      order: 2,
                    }}
                  />
                )
              }
              onDelete={(e) => showReplies(data)}
            />
          )}
          <CustomButton
            id="reply_to_comment_01"
            buttonText={"_reply"}
            variant="text"
            size="small"
            style={{
              fontSize: "10px",
              color: "#282928",
              fontWeight: 700,
              padding: 0,
              marginLeft: "auto",
            }}
            className="btn p-1"
            textVariant="caption"
            tooltip={{
              title: getIntlTranslation("tooltip.reply"),
            }}
            handleClick={(e) => handleReplyClick(data)}
          />
        </Box>
        {showReply && replyContainer(data)}
      </CardContent>
      <Popover
        id={commentsPopOverId}
        open={openPopover}
        anchorEl={anchorEl}
        onClose={handleOptionClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <Box
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            borderRadius: "12px",
            width: "50px",
            height: "90px",
            boxSizing: "border-box",
            boxShadow: "0px 4px 32px 0px #ffff",
            backgroundColor: "#ffff",
            padding: "8px 0px",
          }}
        >
          <CustomIconButton
            id="edit_comment_03"
            icon={<EditIcon style={{ color: "#244a9a", fontSize: 20 }} />}
            permission={null}
            handleClick={(e) => {
              handleEdit(data);
            }}
            tooltip={{
              title: getIntlTranslation("tooltip.edit"),
            }}
            aria-describedby={`edit_comment_03`}
          />

          <CustomIconButton
            id="delete_comment_03"
            icon={
              <DeleteForeverIcon style={{ color: "#f50057", fontSize: 20 }} />
            }
            permission={null}
            handleClick={(e) => handleDeleteClick(data)}
            tooltip={{
              title: getIntlTranslation("tooltip.delete"),
            }}
            aria-describedby={`delete_comment_03`}
          />
        </Box>
      </Popover>
      <Collapse in={open} timeout="auto" unmountOnExit>
        {data.replies && (
          <List
            component="li"
            style={{
              paddingLeft: 1,
            }}
            disablePadding
          >
            {data.replies.map((comment,index) => (
              <RecursiveCommentList
                key={comment.propertyIdent}
                data={comment}
                scrollId={scrollId}
                parentCommentValue={parentCommentValue}
                setInputValue={setInputValue}
                inputValue={inputValue}
                users={users}
                handleDelete={handleDelete}
                handleEditSave={handleEditSave}
                handleReply={handleReply}
                scrollTo={scrollTo}
              />
            ))}
          </List>
        )}
      </Collapse>
    </ListItem>
  );
};

RecursiveCommentList.propTypes = {
  key: PropTypes.string,
  scrollId: PropTypes.string,
  data: PropTypes.object,
  setInputValue: PropTypes.func,
  inputValue: PropTypes.object,
  users: PropTypes.array,
  handleDelete: PropTypes.func,
  handleEditSave: PropTypes.func,
  handleReply: PropTypes.func,
  scrollTo: PropTypes.func,
  parentCommentValue: PropTypes.object,
};

export default RecursiveCommentList;
